import * as Sentry from '@sentry/react';

if (import.meta.env.VITE_SENTRY_ENABLED === 'true') {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    sendDefaultPii: false,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    enableLogs: false,

    // trace everything because we don't know what will result in an error
    tracesSampleRate: 1.0,

    // only record the screen in case of errors
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}
